<template>
    <div :ref="refName" class="rent-select"  @click="clickEvent" @mouseenter="changeArrow(1)" @mouseleave="changeArrow()">
        <span :style="{color: selectColor}" >
            {{selectText}}
            <img class="arrow" :style="{transform: 'rotate('+arrowRotate+'deg)'}" :src="arrowImg" />
        </span>
        <slot v-if="show"></slot>
    </div>
</template>
<script>
export default {
    name: 'RentSelect',
    data () {
        return {
            show: 0,
            selectColor: '#a8a5a4',
            arrowImg: require('../../assets/img/icon/arrow_down_gray.svg'),
            arrowRotate: '0',
            selectText: this.selectMsg,
            isChange: 0
        }
    },
    props: {
        selectMsg: {
            type: String,
            default: '請選擇'
        },
        refName: String,
        setDefault: Boolean
    },
    watch: {
        selectText: function () {
        },
        selectMsg: function () {

        },
        setDefault: function () {
            if(this.setDefault){
                this.selectText = this.selectMsg
                this.isChange = 0
                this.selectColor = '#a8a5a4'
                this.changeArrow()
            }
        }
    },
    mounted () {
        let _this = this;
        let el = _this.$el;
        document.addEventListener('click', function (e) {
            // console.log(e.target != el)
            if( el.contains(e.target) != true){
                _this.dropUp();
                _this.changeArrow()
                if( _this.isChange == 0 ){
                    _this.selectColor = '#a8a5a4'
                }
            }
        })
    },
    methods: {
        dropDown: function () {
            this.show = 1;
        },
        dropUp: function () {
            this.show = 0;
        },
        changeArrow: function (color, rotate) {
            if( color == 1 ){
                this.arrowImg = require('../../assets/img/icon/arrow_down_black.svg')
            }else{
                if(this.show == 1 || this.isChange ==1){
                    this.arrowImg = require('../../assets/img/icon/arrow_down_black.svg')
                }else{
                    this.arrowImg = require('../../assets/img/icon/arrow_down_gray.svg')
                }
            }
            if( rotate == 1 ){
                this.arrowRotate = 180
            }else{
                if(this.show == 1){
                    this.arrowRotate = 180
                }else{
                    this.arrowRotate = 0
                }
                
            }
        },
        clickEvent: function () {
            let tag = event.target.tagName;
            // console.log(tag)
            if( tag == 'LI' ){
                this.dropUp();
                this.isChange = 1
                this.changeArrow()
                
                this.selectText = event.target.innerText.replace(/(<br[^>]*>|\s*)/g,'');
                let data = {
                    id: event.target.dataset.id,
                    name: event.target.dataset.name,
                    ref: this.refName
                };
                this.$emit('getId', data);
            }else{
                this.dropDown()
                this.changeArrow(1, 1)
                this.selectColor = '#676362'
            }
        }
    }
}
</script>
<style   lang="scss">
    .rent-select{
        position: relative;
        padding: 13px 16px;
        border: 1px solid #e0dfde;
        border-radius: 4px;
        cursor: pointer;
        span{
            display: block;
            height: 100%;
            display: flex;
            align-items: center;
            color: #a8a5a4;
            // padding: 5px 10px;
            .arrow{
                position: absolute;
                right: 8px;
            }
        }
        ul{
            position: absolute;
            // display: none; 
            width: 100%;
            padding: 4px 0;
            border-radius: 4px;
            z-index: 6;
            left: -2px;
            top: 47px;
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            border: solid 1px #eeeeee;
            background-color: #f0f0f0;
            li{
                position: relative;
                padding: 12px 16px;
                cursor: pointer;
            }
            li:hover{
                background: #fff;

            }
            .road-filter{
                padding: 12px 16px;
                .search{
                    position: absolute;
                    top: 26px;
                    left: 28px;
                }
                input{
                    padding-left: 38px;
                    width: 112px;
                }
            }
        }
    }
    .rent-select.error{
        border: solid 1px #fc7171 !important;
    }
    .rent-select:hover{
        border: 1px solid #676362;
        span{
            color: #676362;
        }
    }
   
    
</style>


// WEBPACK FOOTER //
// src/components/widge/RentSelect.vue